import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import doc  from '../views/components/file.vue'
import debug from '../views/components/debugResult.vue'


const originalPush = VueRouter.prototype.push
 
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/doc',
    children: [{
      path: 'doc',
      name: 'doc',
      component: doc
    },
    {
      path: 'debug',
      name: 'debug',
      component: debug
    }]
  },
  // {
  //   path: '*',
  //   component: Error
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: '/'/*process.env.BASE_URL*/,
  routes
})


export default router
